import {
  WSCard,
  WSDataItem,
  WSDivider,
  WSElement,
  WSInfoBox,
  WSList,
  WSSectionToolbar,
  WSTable,
  WSTableCell,
  WSTableColumn,
  WSTableItem,
  WSText
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import { WorkLog } from "@wingspanhq/wingspan-api-sdk";
import React from "react";

import { selectorWorkLogLabel } from "../../../WorkLogs/selectors/selectorWorkLogLabel";
import { PAYROLL_CURRENCY } from "../../constants";
import { parsePayrollAmount } from "../../utils";

const columns: WSTableColumn<WorkLog>[] = [
  {
    config: { header: { text: "Worklog" }, gridTemplateSizeMax: "1fr" },
    renderFunction: ({ data }) => (
      <WSTableCell text={selectorWorkLogLabel(data)} />
    )
  },
  {
    config: { header: { text: "Amount" }, justify: "end" },
    renderFunction: ({ data }) => (
      <WSTableCell
        text={formatMoney(
          parsePayrollAmount(data.totalAmount),
          PAYROLL_CURRENCY
        )}
      />
    )
  }
];

type Props = {
  workLogs: WorkLog[];
  workLogsTotal: number;
  onWorkLogOpen?: (id: string) => void;
};

export const PaystubWorkLogsCard: React.FC<Props> = ({
  workLogs,
  workLogsTotal,
  onWorkLogOpen
}) => {
  const tableData: WSTableItem<WorkLog>[] = workLogs.map(workLog => ({
    id: workLog.id ?? "",
    data: workLog
  }));

  return (
    <WSElement>
      <WSSectionToolbar title="Work logs" />
      <WSCard mt="M">
        <WSList gap="M">
          <WSInfoBox>
            <WSText.ParagraphSm color="gray600">
              These are the work logs included in this paystub. To make changes
              to a work log, go to its work log details page.
            </WSText.ParagraphSm>
          </WSInfoBox>

          <WSTable<WorkLog>
            columns={columns}
            tableData={tableData}
            onRowClick={item => onWorkLogOpen?.(item.id)}
          />

          <WSDivider />

          <WSDataItem
            label="Total amount"
            value={formatMoney(workLogsTotal, PAYROLL_CURRENCY)}
          />
        </WSList>
      </WSCard>
    </WSElement>
  );
};
